import {RouteRecordRaw} from 'vue-router'


const authRoutes: Array<RouteRecordRaw> = [
    {
        path: '/auth/google/callback',
        name: 'googleLogin',
        meta: {
            public: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/AuthCallback.vue')
    },

    {
        path: '/auth/microsoft/callback',
        name: 'microsoftLogin',
        meta: {
            public: true,
            no_menu: true
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/AuthCallback.vue')
    },

    {
        path: '/auth/logout',
        name: 'Logout',
        meta: {
            public: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/Logout.vue')
    },
]

export default authRoutes

